import { render, staticRenderFns } from "./GoProctorMini.vue?vue&type=template&id=2bc8da85&scoped=true&"
import script from "./GoProctorMini.vue?vue&type=script&lang=js&"
export * from "./GoProctorMini.vue?vue&type=script&lang=js&"
import style0 from "./GoProctorMini.vue?vue&type=style&index=0&id=2bc8da85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8da85",
  null
  
)

export default component.exports